<template>
  <div v-if="popularList.length> 0" class="article-index-wrap">
    <div class="coverStory">
      <ArticleInfo :article-info="popularList[0]" />
    </div>
    <ArticleOption
      :categories="categories"
      :now-cate="'All'"
    />
    <ArticleList
      :category-name="'All'"
      :is-list="true"
      :is-click-more="true"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import ArticleInfo from '@page/article/components/parts/ArticleInfo.vue';
import ArticleOption from '@page/article/components/parts/ArticleOption';
import ArticleList from '@page/article/components/parts//ArticleList';

const { getArticleCategoryAPI, getArticleListAPI } = useAxiosAPI();

const categories = ref([]);
const popularList = ref([]);

function getCategory() {
  getArticleCategoryAPI()
    .then((res) => {
      if (res.data.Code === 200) {
        categories.value = res.data.Response.Categories;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function getPopularList() {
  getArticleListAPI({
    params: { Category: 'ALL', Limit: 1, Page: 1},
  })
    .then((res) => {
      if (res.data.Code === 200) {
        popularList.value = res.data.Response.Data;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

console.log('created');

getCategory();
getPopularList();
</script>